import Vue from 'vue'
import polyfill from 'babel-polyfill'
import Index from './index.vue'
import { createRouter } from './router/index'
import element from '~config/element-index'
import Raven from 'raven-js'
import RavenVue from './utils/errorHandler'
import { sync } from 'vuex-router-sync'
import Cookies from 'js-cookie'
import {createStore} from '../store/home'

Vue.use(polyfill)

if (process.env.NODE_ENV !== 'development') {
  Raven.config('https://9bf65df05c634e1cb25fdba560e30aaa@sentry.io/256390', {
    dataCallback (data) {
      if (process.env.NODE_ENV === 'testing' || process.env.NODE_ENV === 'pre-release') {
        console.error(data)
      }
      return data
    }
  }).addPlugin(RavenVue, Vue).install()
}

Vue.config.productionTip = false

Vue.use(element)
const store = createStore()
const router = createRouter()
sync(store, router)
window.$$store = store
const app = new Vue({
  store,
  router,
  render: h => h(Index)
})
// 进入登录页面清除token
Cookies.remove('userinfo')
app.$mount('#app')



// WEBPACK FOOTER //
// ./src/index.js